import m from 'mithril';
import selectVehicleModal from "./selectVehicle"
import modalCloseButton from '../../../components/modalCloseButton';

const modal = {
  key: 'VIEW_DRIVER_MODAL',

  show() {
    $(`#${modal.key}`).modal('show');
  },
  hide() {
    $(`#${modal.key}`).modal('hide');
  },
  oninit({ state }) {
    state.loading = false;
  },
  view({ state }) {
    return m('.modal', { id: modal.key },
      [
        m('.modal-dialog.modal-dialog-centered[role="document"]',
          [
            m('.modal-content',
              [
                m('.modal-header',
                  [
                    m('h1.modal-title', 'View Department Details'),
                    m("div", { "class": "btn btn-icon btn-sm btn-active-light-primary ms-2", "data-bs-dismiss": "modal", "aria-label": "Close" },
                      m(modalCloseButton)
                    )
                  ]),
                m('.modal-body',
                  [
                    m('form',
                      [
                        m('div.form-group', [
                          m('label', 'Department Name:'),
                          m('input.form-control[type="text"][placeholder="Enter department name"]', {
                            oninput: (e) => state.driverName = e.target.value,
                          }),
                        ]),
                        m("br"),
                        m('div.form-group', [
                          m('label', 'Department Head:'),
                          m('input.form-control[placeholder="Enter department head name"]', {
                            oninput: (e) => state.driverPhoneNumber = e.target.value,
                          }),
                        ]),
                      ]),
                  ]),
                m('.modal-footer',
                  [
                    m('button.btn.btn-primary.btn-block[type="button"][class="w-100"]', {
                      onclick() {
                        modal.hide();
                        selectVehicleModal.show()
                      },
                    }, 'Continue'),
                  ]),
              ]),
          ]),
      ]);
  },
};


export default modal;
